import { Grid, Menu, MenuItem, MenuList } from "@mui/material";
import { withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Core";
import * as kapi from "api/Knowledge";
import { DefaultListParameters } from "assets/appConfig";
import { GlobalClassKeys, TimelineStyleClasses } from "assets/jss/common-styles";
import AdvFilter, { AdvFilterCommand, AdvFilterComponent, AdvFilterPicker, AdvFilterResult } from "components/AdvFilter";
import { CmdAuthor, CmdDeleted, CmdList, CmdMention, CmdOnlyBlocked, CmdOnlyInstitutional, CmdOnlyNotInstitutional, CmdPoll, CmdPost, CmdPublicationExpired, CmdPublicationFuture, CmdPublicationHighlighted, CmdPublishEndDate, CmdPublishStartDate, CmdQuestion, CmdQuestionWithAnswers, CmdQuestionWithoutAnswers, CmdWithComments, CmdWithDenoncement, CmdWithFile, CmdWithImage, CmdWithLikes, CmdWithOpenDenoncement, CmdWithThanks, CmdWithVideo, CommandLabels } from "components/AdvFilter/CommonCommands";
import { AwardSnackbarMessage } from "components/AwardSnackbarMessage";
import ButtonResetFilter from "components/Buttons/ButtonResetFilter";
import IconButtonAdd from "components/Buttons/IconButtonAdd";
import IconButtonBlocked from "components/Buttons/IconButtonBlocked";
import IconButtonOrderBy from "components/Buttons/IconButtonOrderby";
import IconButtonSubTopic from "components/Buttons/IconButtonSubTopic";
import { RequestIndicator } from "components/CallServer";
import { LoadingIndicator } from "components/CallServer/LoadingIndicator";
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import CountFilter from "components/CountFilter";
import { MuiFilterAdvancedContainer, MuiFilterAppBar, MuiFilterLine, MuiFilterToolbar } from "components/MuiExtras/Filter";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiMenuItemChecked from "components/MuiExtras/MuiMenuItemChecked";
import MuiPagination from "components/MuiExtras/MuiPagination";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import AppMessage from "components/Translations/AppMessage";
import PublicationTypeName from "components/Translations/PublicationTypeName";
import { PublicationType } from "models/ApiEnums";
import { FeedAttachType, GetPublicationAdminListParams, PagedResult, PublicationAdminItemDto, PublicationAdminListFilter, PublicationAdminListOrderBy, SavePublicationResult, TopicSuggestionDto } from "models/ApiModels";
import { RequestLifeCycle } from "models/AppModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import PublicationAdminCard from "views/Publication/Components/PublicationAdminCard";
import { publicationFactory } from "views/Timeline/Components/FeedHelpers";
import TopicAutoComplete from "views/Topic/Components/TopicAutoComplete";

/////////////////////////////////////////////////////////////////////////////////////////////////

export interface PublicationAdminListParameters {
    topic?: AutoCompleteDataModel;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    advFilters: AdvFilterResult[];
    filter: PublicationAdminListFilter;
    orderBy: PublicationAdminListOrderBy;
    selectedTopic: TopicSuggestionDto[];

    list: PagedResult<PublicationAdminItemDto>;
    formCycle: RequestLifeCycle;
    lastError: any;
    offset: number;

    dialog: any;
    orderByMenuAnchorEl: any;
    addByMenuAnchorEl: any;
}

interface IProps {
}

type Props = IProps & WithStyles<typeof TimelineStyleClasses> & RouteComponentProps<any, any, any> & WithSnackbar & WithTranslation;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export class PublicationAdminList extends React.Component<Props, IState> {

    private advFilterRef: AdvFilterComponent;
    private isFiltered: boolean = false;

    constructor(props: Props) {
        super(props);

        let selectedTopic: TopicSuggestionDto[] = [];

        if (this.props.location.state && this.props.location.state.topic) {
            var t = this.props.location.state.topic as AutoCompleteDataModel;
            selectedTopic = [{
                key: t.key,
                label: t.label,
                thumbnailUrl: t.thumbnailUrl,
                canDelete: true,
            }];
        }

        this.state = {
            advFilters: [],
            filter: this.resetFilter(selectedTopic),
            orderBy: PublicationAdminListOrderBy.Title,
            selectedTopic: selectedTopic == null ? [] : selectedTopic,

            list: { items: null, total: 0 },
            offset: 0,
            addByMenuAnchorEl: null,
            orderByMenuAnchorEl: null,
            formCycle: RequestLifeCycle.None,
            lastError: null,
            dialog: null,
        };
    }


    /////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    private loadData(offset: number) {
        const { filter, orderBy } = this.state;

        const p: GetPublicationAdminListParams = {
            filter,
            orderBy,
            range: { offset: offset, take: DefaultListParameters.viewRecordsByPage }
        };

        this.setState({ formCycle: RequestLifeCycle.Loading, orderByMenuAnchorEl: null, dialog: null });

        api.getPublicationAdminList(p)
            .then((result) => {
                this.setState({ list: result, formCycle: RequestLifeCycle.None, offset: offset });
            })
            .catch((error) => {
                this.setState({ list: null, lastError: error, formCycle: RequestLifeCycle.LoadFailed, offset: 0 });
            });
    }

    ///
    private loadBody(publicationId: string) {
        api.getPublicationAdminBody(publicationId)
            .then((body) => {

                var newItems = this.state.list.items.slice(0);
                var pub = newItems.find(p => p.publicationId == publicationId);

                if (pub) {
                    pub.body = body;
                    pub.bodyLoading = false;
                    this.setState({
                        list: {
                            items: newItems,
                            total: this.state.list.total
                        }
                    });
                }
            });
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////

    ///
    private handleActionClose = (result: SavePublicationResult) => {

        if (result && result.award) {
            this.props.snackbar.showMessage(<AwardSnackbarMessage award={result.award} />, "trophy");
        }

        this.setState({ dialog: null }, () => result && this.loadData(this.state.offset));
    };

    ///
    private handleAction(action: string) {
        switch (action) {
            case "list": {
                this.setState({ addByMenuAnchorEl: null, dialog: publicationFactory(null, PublicationType.List, this.handleActionClose, { isPublic: true }) });
                break;
            }
            case "poll": {
                this.setState({ addByMenuAnchorEl: null, dialog: publicationFactory(null, PublicationType.Poll, this.handleActionClose) });
                break;
            }
            case "post": {
                this.setState({ addByMenuAnchorEl: null, dialog: publicationFactory(null, PublicationType.Post, this.handleActionClose) });
                break;
            }
            case "question": {
                this.setState({ addByMenuAnchorEl: null, dialog: publicationFactory(null, PublicationType.Question, this.handleActionClose) });
                break;
            }
        }
    }

    ///
    private buildCreatePublicationMenu() {
        return (
            <>
                <IconButtonAdd
                    color="inherit"
                    title={this.props.t("Common.Buttons.NewPublicationText")}
                    onClick={
                        (e) => {
                            this.setState({ addByMenuAnchorEl: e.currentTarget });
                        }
                    }
                />
                <Menu
                    anchorEl={this.state.addByMenuAnchorEl}
                    open={this.state.addByMenuAnchorEl != null}
                    onClose={
                        () => {
                            this.setState({ addByMenuAnchorEl: null });
                        }}
                >
                    <MenuList role="menu">
                        <MenuItem onClick={(e) => this.handleAction('post')}>
                            <PublicationTypeName publicationType={PublicationType.Post} />
                        </MenuItem>

                        <MenuItem onClick={(e) => this.handleAction('list')}>
                            <PublicationTypeName publicationType={PublicationType.List} />
                        </MenuItem>

                        <MenuItem onClick={(e) => this.handleAction('question')}>
                            <PublicationTypeName publicationType={PublicationType.Question} />
                        </MenuItem>
                    </MenuList>
                </Menu>
            </>
        );
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////

    //#region FILTER

    ///
    private get commands(): AdvFilterCommand[] {
        const cmdLabels = CommandLabels();
        return [
            { keyword: CmdWithLikes, displayName: cmdLabels[CmdWithLikes], group: 1 },
            { keyword: CmdWithComments, displayName: cmdLabels[CmdWithComments], group: 1 },
            { keyword: CmdWithThanks, displayName: cmdLabels[CmdWithThanks], group: 1 },
            { keyword: CmdWithDenoncement, displayName: cmdLabels[CmdWithDenoncement], group: 1 },
            { keyword: CmdWithOpenDenoncement, displayName: cmdLabels[CmdWithOpenDenoncement], group: 1 },

            { keyword: CmdWithVideo, displayName: cmdLabels[CmdWithVideo], group: 2 },
            { keyword: CmdWithImage, displayName: cmdLabels[CmdWithImage], group: 2 },
            { keyword: CmdWithFile, displayName: cmdLabels[CmdWithFile], group: 2 },

            { keyword: CmdPost, displayName: cmdLabels[CmdPost], group: 3 },
            { keyword: CmdQuestion, displayName: cmdLabels[CmdQuestion], group: 3 },
            { keyword: CmdQuestionWithAnswers, displayName: cmdLabels[CmdQuestionWithAnswers], group: 3 },
            { keyword: CmdQuestionWithoutAnswers, displayName: cmdLabels[CmdQuestionWithoutAnswers], group: 3 },
            { keyword: CmdList, displayName: cmdLabels[CmdList], group: 3 },
            { keyword: CmdPoll, displayName: cmdLabels[CmdPoll], group: 3 },

            { keyword: CmdPublishStartDate, displayName: cmdLabels[CmdPublishStartDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdPublishEndDate, displayName: cmdLabels[CmdPublishEndDate], picker: AdvFilterPicker.Calendar, group: 4 },
            { keyword: CmdPublicationHighlighted, displayName: cmdLabels[CmdPublicationHighlighted], group: 4 },
            { keyword: CmdPublicationExpired, displayName: cmdLabels[CmdPublicationExpired], group: 4 },
            { keyword: CmdPublicationFuture, displayName: cmdLabels[CmdPublicationFuture], group: 4 },

            { keyword: CmdMention, displayName: cmdLabels[CmdMention], group: 5, picker: AdvFilterPicker.User, canRepeat: true },
            { keyword: CmdAuthor, displayName: cmdLabels[CmdAuthor], group: 5, picker: AdvFilterPicker.User, canRepeat: true },

            { keyword: CmdOnlyInstitutional, displayName: cmdLabels[CmdOnlyInstitutional], group: 6 },
            { keyword: CmdOnlyNotInstitutional, displayName: cmdLabels[CmdOnlyNotInstitutional], group: 6 },
            { keyword: CmdOnlyBlocked, displayName: cmdLabels[CmdOnlyBlocked], group: 6 },
            { keyword: CmdDeleted, displayName: cmdLabels[CmdDeleted], group: 6 },
        ];
    }

    ///
    private buildOrderByMenu() {
        const { orderBy } = this.state;
        return (
            <>
                <IconButtonOrderBy
                    color="inherit"
                    onClick={
                        (e) => {
                            this.setState({ orderByMenuAnchorEl: e.currentTarget });
                        }
                    }
                />
                <Menu
                    anchorEl={this.state.orderByMenuAnchorEl}
                    open={this.state.orderByMenuAnchorEl != null}
                    onClose={
                        () => {
                            this.setState({ orderByMenuAnchorEl: null });
                        }}
                >
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.Title")} value={PublicationAdminListOrderBy.Title} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent")} value={PublicationAdminListOrderBy.MostRecent} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostViewed")} value={PublicationAdminListOrderBy.MostViews} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostCommented")} value={PublicationAdminListOrderBy.MostComments} currentSelection={orderBy} onClick={this.applyOrder} />
                    <MuiMenuItemChecked text={this.props.t("Common.Filter.Toolbar.OrderBy.MostThanked")} value={PublicationAdminListOrderBy.MostThanks} currentSelection={orderBy} onClick={this.applyOrder} />
                </Menu>
            </>
        );
    }

    ///
    private handleShowBlocked = () => {
        this.setState(
            (state) => {
                state.filter.showBlocked = !state.filter.showBlocked;
                return state;
            }, () => this.loadData(0)
        );
    };

    ///
    private handleShowSubTopics = () => {
        this.setState(
            (state) => {
                state.filter.showSubtopics = !state.filter.showSubtopics;
                return state;
            }, () => this.loadData(0)
        );
    };

    ///
    private resetFilter(selectedTopic: AutoCompleteDataModel[]): PublicationAdminListFilter {
        this.isFiltered = false;

        return {
            topicId: selectedTopic.length == 0 ? null : selectedTopic[0].key,

            searchText: null,
            startDate: null,
            endDate: null,
            showSubtopics: false,
            showBlocked: false,

            attachTypes: null,
            authors: null,
            deleted: null,
            mentions: null,
            onlyBlocked: null,
            onlyInstitutional: null,
            onlyNotInstitutional: null,
            publicationTypes: null,
            withAnswers: null,
            withComments: null,
            withDenouncement: null,
            withLikes: null,
            withNegativeLikes: null,
            withOpenDenouncement: null,
            withThanks: null,

            expired: null,
            future: null,
            highlighted: null
        };
    }

    ///
    private applyOrder = (orderBy: PublicationAdminListOrderBy) => {
        this.setState({ orderBy }, () => this.loadData(0));
    };


    ///
    private buildFilter(searchText: string, advFilters: AdvFilterResult[]): Partial<PublicationAdminListFilter> {
        this.isFiltered = true;

        let withAnswers = false;

        const publicationTypes = [];
        if (advFilters.findIndex(x => x.keyword == CmdPost) > -1) publicationTypes.push(PublicationType.Post);
        if (advFilters.findIndex(x => x.keyword == CmdList) > -1) publicationTypes.push(PublicationType.List);
        if (advFilters.findIndex(x => x.keyword == CmdPoll) > -1) publicationTypes.push(PublicationType.Poll);
        if (advFilters.findIndex(x => x.keyword == CmdQuestion) > -1) publicationTypes.push(PublicationType.Question);
        if (advFilters.findIndex(x => x.keyword == CmdQuestionWithAnswers) > -1) {
            publicationTypes.push(PublicationType.Question);
            withAnswers = true;
        }
        if (advFilters.findIndex(x => x.keyword == CmdQuestionWithoutAnswers) > -1) {
            publicationTypes.push(PublicationType.Question);
            withAnswers = false;
        }

        const attachTypes = [];
        if (advFilters.findIndex(x => x.keyword == CmdWithVideo) > -1) attachTypes.push(FeedAttachType.Video);
        if (advFilters.findIndex(x => x.keyword == CmdWithImage) > -1) attachTypes.push(FeedAttachType.Image);
        if (advFilters.findIndex(x => x.keyword == CmdWithFile) > -1) attachTypes.push(FeedAttachType.File);

        const dtStartDate = advFilters.find(x => x.keyword == CmdPublishStartDate);
        const dtEndDate = advFilters.find(x => x.keyword == CmdPublishEndDate);

        return {
            authors: advFilters.filter(x => x.keyword == CmdAuthor).map(v => v.value),
            mentions: advFilters.filter(x => x.keyword == CmdMention).map(v => v.value),
            publicationTypes: publicationTypes,
            attachTypes: attachTypes,

            withAnswers: withAnswers,
            withLikes: advFilters.findIndex(x => x.keyword == CmdWithLikes) > -1,
            withThanks: advFilters.findIndex(x => x.keyword == CmdWithThanks) > -1,
            withComments: advFilters.findIndex(x => x.keyword == CmdWithComments) > -1,
            withNegativeLikes: false,
            withDenouncement: advFilters.findIndex(x => x.keyword == CmdWithDenoncement) > -1,
            withOpenDenouncement: advFilters.findIndex(x => x.keyword == CmdWithOpenDenoncement) > -1,

            onlyInstitutional: advFilters.findIndex(x => x.keyword == CmdOnlyInstitutional) > -1,
            onlyNotInstitutional: advFilters.findIndex(x => x.keyword == CmdOnlyNotInstitutional) > -1,
            onlyBlocked: advFilters.findIndex(x => x.keyword == CmdOnlyBlocked) > -1,
            deleted: advFilters.findIndex(x => x.keyword == CmdDeleted) > -1,

            searchText: searchText.length == 0 ? null : searchText,

            startDate: dtStartDate ? (dtStartDate.value as Date).putStartOfDay() : null,
            endDate: dtEndDate ? (dtEndDate.value as Date).putEndOfDay() : null,

            highlighted: advFilters.findIndex(x => x.keyword == CmdPublicationHighlighted) > -1,
            expired: advFilters.findIndex(x => x.keyword == CmdPublicationExpired) > -1,
            future: advFilters.findIndex(x => x.keyword == CmdPublicationFuture) > -1
        };
    }

    ///
    private updateFilter = (searchText: string, advFilters: AdvFilterResult[]) => {
        const newFilter = (searchText.length == 0 && advFilters.length == 0)
            ? this.resetFilter(this.state.selectedTopic)
            : this.buildFilter(searchText, advFilters);

        this.setState(
            {
                filter: { ...this.state.filter, ...newFilter },
                advFilters
            }, () => this.loadData(0)
        );
    };

    ///
    private updateTopicSelection = (items: TopicSuggestionDto[]) => {
        this.setState((state) => {
            state.filter.topicId = items.length == 0 ? null : items[0].key;
            return { ...state, selectedTopic: items, };
        }, () => this.loadData(0));
    };

    ///
    private renderAdvFilter(): JSX.Element {
        const { filter, selectedTopic } = this.state;

        return (
            <MuiFilterAppBar position="static">
                <MuiFilterToolbar variant="dense" >
                    <MuiFilterLine>
                        <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                            <Grid item>
                                {this.buildCreatePublicationMenu()}
                            </Grid>
                            <Grid item className={GlobalClassKeys.grow}>
                                <TopicAutoComplete
                                    id="topicFilter"
                                    placeholder={this.props.t("Views.Publication.PublicationAdminList.TopicPlaceholder")}
                                    margin={"normal"}
                                    chipColor="info"
                                    multiple={false}
                                    showAvatar={false}
                                    selectedItems={selectedTopic}
                                    onChange={this.updateTopicSelection}
                                />
                            </Grid>

                            {
                                this.state.selectedTopic.length > 0 &&
                                <Grid item>
                                    <IconButtonSubTopic
                                        title={this.props.t("Views.Publication.PublicationAdminList.ButtonIncludeSubtopicsTitle")}
                                        color={filter.showSubtopics ? "warning" : "inherit"}
                                        onClick={this.handleShowSubTopics}
                                    />
                                </Grid>
                            }

                            <Grid item>
                                <IconButtonBlocked
                                    title={this.props.t("Views.Publication.PublicationAdminList.ButtonBlockTitle")}
                                    color={filter.showBlocked ? "warning" : "inherit"}
                                    onClick={this.handleShowBlocked}
                                />
                            </Grid>

                            <Grid item>
                                {this.buildOrderByMenu()}
                            </Grid>
                        </Grid>
                    </MuiFilterLine>

                    <MuiFilterAdvancedContainer disableMargins>
                        <AdvFilter
                            id="advfilter"
                            commands={this.commands}
                            innerRef={(ref) => this.advFilterRef = ref}
                            placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                            placeHolderFocus={this.props.t("Common.Filter.Adv.InputPlaceholderFocus")}
                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                            selectedCommands={this.state.advFilters}
                            onUpdateSelection={this.updateFilter} />
                    </MuiFilterAdvancedContainer>
                </MuiFilterToolbar>
            </MuiFilterAppBar>
        );
    }

    //#endregion

    ///
    private handleEdit = (publicationId: string, publicationType: PublicationType) => {

        this.setState({
            dialog: publicationFactory(publicationId, publicationType,
                (pubId) => this.setState(
                    { dialog: null },
                    () => pubId && this.loadData(this.state.offset)
                )
            )
        });
    };

    ///
    private handleDelete = (publicationId: string, publicationType: PublicationType) => {

        this.setState({
            dialog: <MuiConfirmation
                title={this.props.t("Views.Publication.PublicationAdminList.ConfirmationDeleteTitle")}
                message={this.props.t("Views.Publication.PublicationAdminList.ConfirmationDeleteMessage")}
                onClose={
                    (result) => {
                        if (result) {

                            this.setState({ dialog: null, formCycle: RequestLifeCycle.Posting });

                            kapi.deletePublication(publicationId, publicationType)
                                .then((result) => {
                                    if (result) this.loadData(this.state.offset);
                                    else this.props.snackbar.showMessage(<AppMessage resource="OperationFailed" />, "error");
                                })
                                .catch((error) => {
                                    this.setState({ dialog: null, lastError: error, formCycle: RequestLifeCycle.PostFailed });
                                });
                        }
                        else {
                            this.setState({ dialog: null });
                        }
                    }
                }
            />
        });
    };

    ///
    private handleExpand = (publicationId: string, publicationType: PublicationType) => {

        var newItems = this.state.list.items.slice(0);
        var pub = newItems.find(p => p.publicationId == publicationId);
        if (pub) {
            if (pub.body != null) pub.body = null;
            else pub.bodyLoading = true;

            this.setState({
                list: {
                    items: newItems,
                    total: this.state.list.total
                }
            }, () => {
                if (pub.bodyLoading) this.loadBody(publicationId);
            });
        }
    };

    ///
    private renderItems() {
        const { list } = this.state;

        if (list.total == 0 && !this.isFiltered)
            return <MuiMessageBox variant="info" message={this.props.t("Common.Feed.Filter.PublicationResultText_zero")} />;

        if (list.total == 0 && this.isFiltered)
            return <MuiMessageBox
                variant="warning"
                action={<ButtonResetFilter color="warning" onClick={() => this.advFilterRef.resetFilter()} />}
                message={this.props.t("Common.Feed.Filter.PublicationFilteredResultText_zero")}
            />;

        return (
            <div>
                <MuiContainer margin="normal">
                    <MuiContainer margin="normal">
                        <CountFilter
                            count={list.total}
                            filtered={this.isFiltered}
                            resource="Common.Feed.Filter.PublicationResultText"
                            filteredResource="Common.Feed.Filter.PublicationFilteredResultText"
                            onResetFilter={() => this.advFilterRef.resetFilter()}
                        />
                    </MuiContainer>

                    {
                        list.items.map((item, index) => (
                            <MuiContainer margin="dense" key={index}>
                                <PublicationAdminCard
                                    item={item}
                                    onDelete={this.handleDelete}
                                    onEdit={this.handleEdit}
                                    onExpand={this.handleExpand}
                                    onNeedReload={() => this.loadData(this.state.offset)}
                                />
                            </MuiContainer>
                        ))
                    }
                    <MuiPagination
                        limit={DefaultListParameters.viewRecordsByPage}
                        offset={this.state.offset}
                        total={this.state.list.total}
                        onClick={(e, offset) => this.loadData(offset)}
                    />
                </MuiContainer>
            </div>
        );
    }

    ///
    private renderList() {
        const { lastError, formCycle } = this.state;

        if (formCycle == RequestLifeCycle.LoadFailed)
            return <RequestErrorReport error={lastError} />;

        return (
            <>
                <RequestErrorDialog
                    open={formCycle == RequestLifeCycle.PostFailed}
                    error={lastError}
                    onClose={() => this.setState({ lastError: null, formCycle: RequestLifeCycle.None })}
                />

                <RequestIndicator
                    open={formCycle == RequestLifeCycle.Posting}
                    type="post"
                />

                <MuiContainer margin="normal">
                    {this.renderAdvFilter()}
                </MuiContainer>

                {
                    formCycle == RequestLifeCycle.Loading
                        ? <LoadingIndicator />
                        : this.renderItems()
                }
            </>
        );
    }

    ///
    public componentDidMount() {
        this.loadData(0);
    }

    ///
    public render() {
        return (
            <div className={this.props.classes.timelineContainer}>
                {this.state.dialog}
                {this.renderList()}
            </div>
        );
    }
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export default withSnackbar(withTranslation()(withStyles(TimelineStyleClasses)(PublicationAdminList)));